// eslint-disable-next-line
export const getDesktopStatuses = state => state.ws.desktopStatuses;
